// node modules
import React from 'react';
import { observer } from 'mobx-react';
// ui library
import { Text, View } from '@upstox/upstox-ui';
// modules
import FormatService from 'modules/Format';
import { useStore } from 'modules/Stores';
// styles
import * as rowCss from '../styles';
import * as css from './styles';
// components
import OptionChainCell from '../OptionChainCell/OptionChainCell';

const OptionChainVolumeCell: React.FC<OptionChainTableCellProps> = ({
  instrumentKey,
  isCall,
}) => {
  const { maxTotalVolume } = useStore('OptionChainStore');
  const { getOptionParamValueWithInstrumentKey } = useStore('LiveDataStore');

  const totalVolume = getOptionParamValueWithInstrumentKey(
    instrumentKey,
    'totalVolume',
  );

  const valueToday = Number(totalVolume) || 0;
  const labelValue =
    valueToday !== 0
      ? FormatService.formatToIndianFloat(valueToday / 100000, 2)
      : '-';
  const topValuePercentage = Math.round((valueToday / maxTotalVolume) * 100);

  return (
    <OptionChainCell>
      <View
        flex
        css={css.oiCell}
        flexDirection={isCall ? 'row' : 'row-reverse'}
      >
        <View css={css.barContainer} cssProps={{ isCall }}>
          <View
            aria-label={`${valueToday}`}
            css={css.topBar}
            cssProps={{ variant: isCall ? 'positive' : 'negative', isCall }}
            style={{ width: `${topValuePercentage}%` }}
          />
        </View>

        <View css={css.labelContainer} cssProps={{ isCall }}>
          <Text
            color="text.1"
            variant="meta"
            size="m"
            lineHeight="l"
            css={rowCss.optionChainCell}
          >
            {labelValue}
          </Text>
        </View>
      </View>
    </OptionChainCell>
  );
};

export default observer(OptionChainVolumeCell);
